'use strict';

require('lazysizes/plugins/object-fit/ls.object-fit');

require('lazysizes/plugins/parent-fit/ls.parent-fit');

require('lazysizes/plugins/rias/ls.rias');

require('lazysizes/plugins/bgset/ls.bgset');

require('lazysizes');

require('lazysizes/plugins/respimg/ls.respimg');

require('../../styles/theme.scss');

var _themeA11y = require('@shopify/theme-a11y');

var _themeCart = require('@shopify/theme-cart');

var _accordions = require('./accordions');

var _accordions2 = _interopRequireDefault(_accordions);

var _animateToScroll = require('./animate-to-scroll');

var _animateToScroll2 = _interopRequireDefault(_animateToScroll);

var _cartPage = require('./cart-page');

var _cartPage2 = _interopRequireDefault(_cartPage);

var _colourBlockParallax = require('./colour-block-parallax');

var _colourBlockParallax2 = _interopRequireDefault(_colourBlockParallax);

var _customer = require('./customer');

var _customer2 = _interopRequireDefault(_customer);

var _dropdown = require('./dropdown');

var _dropdown2 = _interopRequireDefault(_dropdown);

var _error = require('./error');

var _error2 = _interopRequireDefault(_error);

var _faqAccordion = require('./faq-accordion');

var _faqAccordion2 = _interopRequireDefault(_faqAccordion);

var _faqMobileContact = require('./faq-mobile-contact');

var _faqMobileContact2 = _interopRequireDefault(_faqMobileContact);

var _exitIntent = require('./exit-intent');

var _exitIntent2 = _interopRequireDefault(_exitIntent);

var _freeSampleSale = require('./free-sample-sale');

var _freeSampleSale2 = _interopRequireDefault(_freeSampleSale);

var _helpers = require('./helpers');

var _helpers2 = _interopRequireDefault(_helpers);

var _ingredientsAccordion = require('./ingredients-accordion');

var _ingredientsAccordion2 = _interopRequireDefault(_ingredientsAccordion);

var _inlineCart = require('./inline-cart');

var _inlineCart2 = _interopRequireDefault(_inlineCart);

var _instagram = require('./instagram');

var _instagram2 = _interopRequireDefault(_instagram);

var _magnificPopup = require('./magnific-popup');

var _magnificPopup2 = _interopRequireDefault(_magnificPopup);

var _mobileImageCheck = require('./mobile-image-check');

var _mobileImageCheck2 = _interopRequireDefault(_mobileImageCheck);

var _modal = require('./modal');

var _modal2 = _interopRequireDefault(_modal);

var _navigation = require('./navigation');

var _navigation2 = _interopRequireDefault(_navigation);

var _overlay = require('./overlay');

var _overlay2 = _interopRequireDefault(_overlay);

var _productDetailParallax = require('./product-detail-parallax');

var _productDetailParallax2 = _interopRequireDefault(_productDetailParallax);

var _productImages = require('./product-images');

var _productImages2 = _interopRequireDefault(_productImages);

var _productSubscriptions = require('./product-subscriptions');

var _productSubscriptions2 = _interopRequireDefault(_productSubscriptions);

var _retinaImages = require('./retina-images');

var _retinaImages2 = _interopRequireDefault(_retinaImages);

var _scroll = require('./scroll');

var _scroll2 = _interopRequireDefault(_scroll);

var _sliders = require('./sliders');

var _sliders2 = _interopRequireDefault(_sliders);

var _stickyContent = require('./sticky-content');

var _stickyContent2 = _interopRequireDefault(_stickyContent);

var _storyPage = require('./story-page');

var _storyPage2 = _interopRequireDefault(_storyPage);

var _subscriptionPage = require('./subscription-page');

var _subscriptionPage2 = _interopRequireDefault(_subscriptionPage);

var _testimonialSwitcher = require('./testimonial-switcher');

var _testimonialSwitcher2 = _interopRequireDefault(_testimonialSwitcher);

var _textParallax = require('./text-parallax');

var _textParallax2 = _interopRequireDefault(_textParallax);

var _yotpoReviews = require('./yotpo-reviews');

var _yotpoReviews2 = _interopRequireDefault(_yotpoReviews);

var _quiz = require('./quiz');

var _quiz2 = _interopRequireDefault(_quiz);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Common a11y fixes

// import newsletterPopup from './newsletter-popup';

// import lazyLoad from './lazy-load';
(0, _themeA11y.focusHash)();
// import pressPage from './press-page';

// import rivets from 'rivets';
// import CartJS from 'shopify-cartjs';

(0, _themeA11y.bindInPageLinks)();
(0, _accordions2.default)();
(0, _animateToScroll2.default)();
(0, _cartPage2.default)();
(0, _colourBlockParallax2.default)();
(0, _customer2.default)();
(0, _dropdown2.default)();
(0, _error2.default)();
(0, _faqAccordion2.default)();
(0, _faqMobileContact2.default)();
(0, _exitIntent2.default)();
(0, _freeSampleSale2.default)();
(0, _helpers2.default)();
(0, _ingredientsAccordion2.default)();
(0, _inlineCart2.default)();
(0, _instagram2.default)();
// lazyLoad();
(0, _magnificPopup2.default)();
(0, _mobileImageCheck2.default)();
(0, _modal2.default)();
(0, _navigation2.default)();
// newsletterPopup();
(0, _overlay2.default)();
// pressPage();
(0, _productDetailParallax2.default)();
(0, _productImages2.default)();
(0, _productSubscriptions2.default)();
(0, _retinaImages2.default)();
(0, _scroll2.default)();
(0, _sliders2.default)();
(0, _stickyContent2.default)();
(0, _storyPage2.default)();
(0, _subscriptionPage2.default)();
(0, _testimonialSwitcher2.default)();
(0, _textParallax2.default)();
(0, _yotpoReviews2.default)();
(0, _quiz2.default)();

window.Accordions.init();
window.AOS.init();
window.Cart.init();
window.ColourBlockParallax.init();
window.Customer.init();
window.Dropdown.init();
window.ErrorPage.init();
window.FAQAccordion.init();
window.FAQMobileContact.init();
window.FreeSampleSale.init();
window.IngredientsAccordion.init();
window.InlineCart.init();
window.Instagram.init();
// window.LazyLoad.init();
window.MagnificPopup.init();
window.MobileImageCheck.init();
window.Modal.init();
window.Navigation.init();
// window.NewsletterPopup.init();
window.Overlay.init();
// window.PressPage.init();
window.ProductDetailParallax.init();
window.ProductImages.init();
window.ProductSubscription.init();
window.RetinaImages.init();
window.Scroll.init();
window.Sliders.init();
window.StickyContent.init();
window.StoryPage.init();
window.SubscriptionPage.init();
window.TestimonialSwitcher.init();
window.TextParallax.init();
window.YotpoReviews.init();
//window.CartJS.init(window.cartObj);
window.Quiz.init();

// Apply a specific class to the html element for browser support of cookies.
/*if (cookiesEnabled()) {
  document.documentElement.className = document.documentElement.className.replace(
    'supports-no-cookies',
    'supports-cookies',
  );
}*/